import catalogPreview from './catalog/hero_preview.webp';
import heroFull from './hero/hero_full.webp';

import comparison01SourcePreview from './comparisons/comparison-01/source/Facad_1_cloud_preview.webp';
import comparison01SourceFull from './comparisons/comparison-01/source/Facad_1_cloud_full.webp';
import comparison01ResultPreview from './comparisons/comparison-01/result/Facad_1_preview.webp';
import comparison01ResultPreviewDark from './comparisons/comparison-01/result/Facad_1_preview_dark.webp';
import comparison01ResultFull from './comparisons/comparison-01/result/Facad_1_full.webp';
import comparison01ResultFullDark from './comparisons/comparison-01/result/Facad_1_full_dark.webp';

import comparison02SourcePreview from './comparisons/comparison-02/source/Facad_2_cloud_preview.webp';
import comparison02SourceFull from './comparisons/comparison-02/source/Facad_2_cloud_full.webp';
import comparison02ResultPreview from './comparisons/comparison-02/result/Facad_2_preview.webp';
import comparison02ResultPreviewDark from './comparisons/comparison-02/result/Facad_2_preview_dark.webp';
import comparison02ResultFull from './comparisons/comparison-02/result/Facad_2_full.webp';
import comparison02ResultFullDark from './comparisons/comparison-02/result/Facad_2_full_dark.webp';

import comparison03SourcePreview from './comparisons/comparison-03/source/Plan_cloud_preview.webp';
import comparison03SourceFull from './comparisons/comparison-03/source/Plan_cloud_full.webp';
import comparison03ResultPreview from './comparisons/comparison-03/result/Plan_preview.webp';
import comparison03ResultPreviewDark from './comparisons/comparison-03/result/Plan_preview_dark.webp';
import comparison03ResultFull from './comparisons/comparison-03/result/Plan_full.webp';
import comparison03ResultFullDark from './comparisons/comparison-03/result/Plan_full_dark.webp';

import comparison04SourcePreview from './comparisons/comparison-04/source/Section_A_cloud_preview.webp';
import comparison04SourceFull from './comparisons/comparison-04/source/Section_A_cloud_full.webp';
import comparison04ResultPreview from './comparisons/comparison-04/result/Section_A_preview.webp';
import comparison04ResultPreviewDark from './comparisons/comparison-04/result/Section_A_preview_dark.webp';
import comparison04ResultFull from './comparisons/comparison-04/result/Section_A_full.webp';
import comparison04ResultFullDark from './comparisons/comparison-04/result/Section_A_full_dark.webp';

import comparison05SourcePreview from './comparisons/comparison-05/source/Section_B_cloud_preview.webp';
import comparison05SourceFull from './comparisons/comparison-05/source/Section_B_cloud_full.webp';
import comparison05ResultPreview from './comparisons/comparison-05/result/Section_B_preview.webp';
import comparison05ResultPreviewDark from './comparisons/comparison-05/result/Section_B_preview_dark.webp';
import comparison05ResultFull from './comparisons/comparison-05/result/Section_B_full.webp';
import comparison05ResultFullDark from './comparisons/comparison-05/result/Section_B_full_dark.webp';

import result01Preview from './results/result-01/1_preview.webp';
import result01PreviewDark from './results/result-01/1_preview_dark.webp';
import result01Full from './results/result-01/1_full.webp';
import result01FullDark from './results/result-01/1_full_dark.webp';
import result02Preview from './results/result-02/2_preview.webp';
import result02PreviewDark from './results/result-02/2_preview_dark.webp';
import result02Full from './results/result-02/2_full.webp';
import result02FullDark from './results/result-02/2_full_dark.webp';
import result03Preview from './results/result-03/3_preview.webp';
import result03PreviewDark from './results/result-03/3_preview_dark.webp';
import result03Full from './results/result-03/3_full.webp';
import result03FullDark from './results/result-03/3_full_dark.webp';
import result04Preview from './results/result-04/4_preview.webp';
import result04PreviewDark from './results/result-04/4_preview_dark.webp';
import result04Full from './results/result-04/4_full.webp';
import result04FullDark from './results/result-04/4_full_dark.webp';
import result05Preview from './results/result-05/5_preview.webp';
import result05PreviewDark from './results/result-05/5_preview_dark.webp';
import result05Full from './results/result-05/5_full.webp';
import result05FullDark from './results/result-05/5_full_dark.webp';
import result06Preview from './results/result-06/6_preview.webp';
import result06PreviewDark from './results/result-06/6_preview_dark.webp';
import result06Full from './results/result-06/6_full.webp';
import result06FullDark from './results/result-06/6_full_dark.webp';
import result07Preview from './results/result-07/7_preview.webp';
import result07PreviewDark from './results/result-07/7_preview_dark.webp';
import result07Full from './results/result-07/7_full.webp';
import result07FullDark from './results/result-07/7_full_dark.webp';
import result08Preview from './results/result-08/8_preview.webp';
import result08PreviewDark from './results/result-08/8_preview_dark.webp';
import result08Full from './results/result-08/8_full.webp';
import result08FullDark from './results/result-08/8_full_dark.webp';
import result09Preview from './results/result-09/9_preview.webp';
import result09PreviewDark from './results/result-09/9_preview_dark.webp';
import result09Full from './results/result-09/9_full.webp';
import result09FullDark from './results/result-09/9_full_preview.webp';

const image = ({
  preview,
  previewDark = preview,
  full = preview,
  fullDark = full,
  alt,
  label,
}) => ({
  preview,
  previewDark,
  full,
  fullDark,
  alt,
  ...(label ? { label } : {}),
});

const comparison = ({
  id,
  sourcePreview,
  sourceFull,
  sourceAlt,
  resultPreview,
  resultPreviewDark,
  resultFull,
  resultFullDark,
  resultAlt,
}) => ({
  id,
  source: image({
    preview: sourcePreview,
    full: sourceFull,
    alt: sourceAlt,
    label: 'Облако точек',
  }),
  result: image({
    preview: resultPreview,
    previewDark: resultPreviewDark,
    full: resultFull,
    fullDark: resultFullDark,
    alt: resultAlt,
    label: '2D-документация',
  }),
});

const result = (id, preview, previewDark, full, fullDark, alt) => ({
  id,
  ...image({ preview, previewDark, full, fullDark, alt }),
});

export const project03Images = {
  catalog: image({
    preview: catalogPreview,
    alt: 'Обмерная 2D-документация церкви, подготовленная по облаку точек',
  }),
  hero: image({
    preview: heroFull,
    full: heroFull,
    alt: 'Облако точек существующего здания церкви',
  }),
  comparisons: [
    comparison({
      id: 'comparison-01',
      sourcePreview: comparison01SourcePreview,
      sourceFull: comparison01SourceFull,
      sourceAlt: 'Фрагмент облака точек, использованный для построения фасада 1',
      resultPreview: comparison01ResultPreview,
      resultPreviewDark: comparison01ResultPreviewDark,
      resultFull: comparison01ResultFull,
      resultFullDark: comparison01ResultFullDark,
      resultAlt: 'Фасад 1 из итогового комплекта обмерной 2D-документации',
    }),
    comparison({
      id: 'comparison-02',
      sourcePreview: comparison02SourcePreview,
      sourceFull: comparison02SourceFull,
      sourceAlt: 'Фрагмент облака точек, использованный для построения фасада 2',
      resultPreview: comparison02ResultPreview,
      resultPreviewDark: comparison02ResultPreviewDark,
      resultFull: comparison02ResultFull,
      resultFullDark: comparison02ResultFullDark,
      resultAlt: 'Фасад 2 из итогового комплекта обмерной 2D-документации',
    }),
    comparison({
      id: 'comparison-03',
      sourcePreview: comparison03SourcePreview,
      sourceFull: comparison03SourceFull,
      sourceAlt: 'Фрагмент облака точек, использованный для построения плана этажа церкви',
      resultPreview: comparison03ResultPreview,
      resultPreviewDark: comparison03ResultPreviewDark,
      resultFull: comparison03ResultFull,
      resultFullDark: comparison03ResultFullDark,
      resultAlt: 'План этажа из итогового комплекта обмерной 2D-документации',
    }),
    comparison({
      id: 'comparison-04',
      sourcePreview: comparison04SourcePreview,
      sourceFull: comparison04SourceFull,
      sourceAlt: 'Фрагмент облака точек, использованный для построения разреза A',
      resultPreview: comparison04ResultPreview,
      resultPreviewDark: comparison04ResultPreviewDark,
      resultFull: comparison04ResultFull,
      resultFullDark: comparison04ResultFullDark,
      resultAlt: 'Разрез A из итогового комплекта обмерной 2D-документации',
    }),
    comparison({
      id: 'comparison-05',
      sourcePreview: comparison05SourcePreview,
      sourceFull: comparison05SourceFull,
      sourceAlt: 'Фрагмент облака точек, использованный для построения разреза B',
      resultPreview: comparison05ResultPreview,
      resultPreviewDark: comparison05ResultPreviewDark,
      resultFull: comparison05ResultFull,
      resultFullDark: comparison05ResultFullDark,
      resultAlt: 'Разрез B из итогового комплекта обмерной 2D-документации',
    }),
  ],
  results: [
    result('result-01', result01Preview, result01PreviewDark, result01Full, result01FullDark, 'Обмерный план этажа церкви'),
    result('result-02', result02Preview, result02PreviewDark, result02Full, result02FullDark, 'Обмерный план верхнего уровня церкви'),
    result('result-03', result03Preview, result03PreviewDark, result03Full, result03FullDark, 'Обмерный план кровли церкви'),
    result('result-04', result04Preview, result04PreviewDark, result04Full, result04FullDark, 'Согласованный чертёж геометрии кровли церкви'),
    result('result-05', result05Preview, result05PreviewDark, result05Full, result05FullDark, 'Обмерный фасад 1 церкви'),
    result('result-06', result06Preview, result06PreviewDark, result06Full, result06FullDark, 'Обмерные фасады 2 и 4 церкви'),
    result('result-07', result07Preview, result07PreviewDark, result07Full, result07FullDark, 'Обмерный фасад 3 церкви'),
    result('result-08', result08Preview, result08PreviewDark, result08Full, result08FullDark, 'Продольный разрез A церкви'),
    result('result-09', result09Preview, result09PreviewDark, result09Full, result09FullDark, 'Поперечные разрезы B и C церкви'),
  ],
};
